import { handleDocumentUploadEvent } from './handleDocumentUploadEvent'
import { insertNewShare } from './insertNewShare'
import { useVersionUploadCompleteSubscription } from 'gqlTypes'
import { readShareListItemFromCache } from 'modules/shares/operations'

export const useVersionUploadComplete = () => {
  useVersionUploadCompleteSubscription({
    onSubscriptionData: ({ client, subscriptionData }) => {
      const share = subscriptionData.data?.versionUploadComplete
      if (!share) return

      const cachedShare = readShareListItemFromCache({
        cache: client,
        id: share.identifier,
      })

      /**
       * To see if we have to create a new share we just look for an entry in
       * the user's cache, if it already exists we just skip it.
       */
      if (!cachedShare) {
        insertNewShare(client, share.identifier)
      }

      handleDocumentUploadEvent(client, share)
    },
    variables: { limit: 3 },
    fetchPolicy: 'no-cache',
  })
}
